module.exports = __webpack_public_path__ + "img/main_page_img.07774d03.svg";